import * as React from "react";
export var LineContext = /*#__PURE__*/ React.createContext({
    lineId: undefined
});
